import * as React from 'react'
import { ConversationMessageNote } from "../../../../../types";
import MessageParagraph from "../MessageParagraph";
import showdown from '../../../../../utilities/showdown';

interface IProps {
  message: ConversationMessageNote
}

const Note = (props: IProps) => {
  const { message } = props

  return (
    <MessageParagraph
      dangerouslySetInnerHTML={{ __html: showdown.makeHtml(message.content) }}
    />
  )
}

export default Note